<template>
<div>Carregando...</div>
</template>
<script>
import Auth from '../../services/auth'
let win = this;
export default {
  data() {
    return {
    }
  },
  computed: {

  },
  created() {
    Auth.loginSSA(this.$route.query.taxIdNumber, this.$route.query.sessionId).then(r => {
      this.$router.push({name: 'plans'});
    });
  }
}
</script>



// WEBPACK FOOTER //
// login-ssa.vue?2f2e62d3